import { AccessLevel } from "@core/api";
import { AccessTableUtils } from "../AccessTableUtils.js";
var isPartOfGroup = function(groupAccessModels, groupId) {
    return groupAccessModels.find(function(accessModel) {
        return accessModel.id === groupId && accessModel.callerPartOf;
    }) !== undefined;
};
var isPartOfGroupWithFullEditAccess = function(groupAccessModels) {
    var editGroupsPartOf = groupAccessModels.filter(function(accessModel) {
        return accessModel.accessLevel === AccessLevel.EDIT_ALL && accessModel.callerPartOf;
    });
    return editGroupsPartOf.length > 0;
};
var isPartOfGroupThatCanEdit = function(groupAccessModels, resourceId) {
    var groupThatCanEdit = groupAccessModels.find(function(accessModel) {
        return accessModel.callerPartOf && AccessTableUtils.hasEditAccessOnResource(accessModel, resourceId);
    });
    return groupThatCanEdit !== undefined;
};
var preventGroupLockout = function(groupAccessModels, resourceId) {
    var isNewResource = AccessTableUtils.isNewResource(resourceId);
    var partOfGroupWithFullEditAccess = isPartOfGroupWithFullEditAccess(groupAccessModels);
    return groupAccessModels.map(function(groupAccessModel) {
        if (isNewResource && AccessTableUtils.isModifiableAccess(groupAccessModel) && groupAccessModel.callerPartOf && !partOfGroupWithFullEditAccess) {
            // When creating a resource, we grant edit access to the group the user is part of by default if he cannot edit all groups, otherwise he might lose access to the resource after creation
            return AccessTableUtils.setEditAccessOnResource(groupAccessModel, resourceId);
        }
        return groupAccessModel;
    });
};
export var GroupsAccessTableUtils = {
    isPartOfGroup: isPartOfGroup,
    isPartOfGroupThatCanEdit: isPartOfGroupThatCanEdit,
    preventGroupLockout: preventGroupLockout
};

//# sourceMappingURL=GroupsAccessTableUtils.js.map